import { graphql } from "react-relay";

export const UpdateAccountMutation = graphql`
  mutation UpdateAccountMutation($input: UpdateAccountInput!) {
    updateAccount(input: $input) {
      account {
        credentialInfo {
          ... on AzureCredentialInfo {
            clientID
            tenantID
          }
          ... on TencentCloudCredentialInfo {
            keyID
          }
        }
        email
        id
        key
        name
        path
        provider
        securityContext
        statusInfo {
          details {
            at
            component
            message
            status
          }
        }
      }
    }
  }
`;
